import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createTextVNode as _createTextVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SogCard from "@/shared/ui/SogCard.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import ProductPrice from "@/shared/model/productPrice";
import SogDataLabel from "@/shared/ui/SogDataLabel.vue";
import {ProductType} from "@/shared/model/productType";
import {computed} from "vue";

interface Props {
  price?: ProductPrice
  isSelected?: boolean | string
  allowSelect?: boolean | string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ProductPriceCardComponent',
  props: {
    price: { default: undefined },
    isSelected: { type: [Boolean, String], default: undefined },
    allowSelect: { type: [Boolean, String], default: undefined }
  },
  setup(__props: any) {

const props = __props


const _classCard = computed(() => {
  let res = "sog-card"
  if (props.isSelected) {
    res += " selected"
  }
  if (props.allowSelect) {
    res += " allow-select"
  }
  return res

})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogCard, {
    class: _normalizeClass(_classCard.value)
  }, {
    default: _withCtx(() => [
      _createVNode(SogCardContent, null, {
        default: _withCtx(() => [
          _createElementVNode("table", null, [
            _withDirectives(_createElementVNode("tr", null, [
              _createElementVNode("td", null, [
                _createVNode(SogDataLabel, {
                  value: __props.price?.productName
                }, null, 8, ["value"])
              ])
            ], 512), [
              [_vShow, __props.price?.productTypeId===_unref(ProductType).ExportBlank]
            ]),
            _withDirectives(_createElementVNode("tr", null, [
              _createElementVNode("td", null, [
                _createVNode(SogDataLabel, {
                  value: __props.price?.productName
                }, null, 8, ["value"])
              ])
            ], 512), [
              [_vShow, __props.price?.productTypeId===_unref(ProductType).Addition || __props.price?.productTypeId===_unref(ProductType).None]
            ]),
            _withDirectives(_createElementVNode("tr", null, [
              _createElementVNode("td", null, [
                _createVNode(SogDataLabel, {
                  value: __props.price?.carTypeName
                }, null, 8, ["value"]),
                _cache[0] || (_cache[0] = _createTextVNode("   ", -1)),
                _withDirectives(_createVNode(SogDataLabel, {
                  value: __props.price?.territoryTypeName
                }, null, 8, ["value"]), [
                  [_vShow, __props.price?.productTypeId===_unref(ProductType).Kzk]
                ]),
                _cache[1] || (_cache[1] = _createTextVNode("   ", -1)),
                _withDirectives(_createVNode(SogDataLabel, {
                  value: __props.price?.validityDay
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("span", null, " Tage ", 512), [
                      [_vShow, __props.price?.validityDay!==1]
                    ]),
                    _withDirectives(_createElementVNode("span", null, " Tag ", 512), [
                      [_vShow, __props.price?.validityDay===1]
                    ])
                  ]),
                  _: 1
                }, 8, ["value"]), [
                  [_vShow, __props.price?.productTypeId===_unref(ProductType).Zoll||__props.price?.productTypeId===_unref(ProductType).Kzk]
                ])
              ])
            ], 512), [
              [_vShow, __props.price?.productTypeId!==_unref(ProductType).Addition && __props.price?.productTypeId!==_unref(ProductType).None && __props.price?.productTypeId!==_unref(ProductType).ExportBlank]
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, [
                _createVNode(SogDataLabel, {
                  value: __props.price?.manufacturerName
                }, null, 8, ["value"])
              ])
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, [
                _createVNode(SogDataLabel, {
                  value: __props.price?.supplierName
                }, null, 8, ["value"])
              ])
            ]),
            _withDirectives(_createElementVNode("tr", null, [
              _createElementVNode("td", null, [
                _createVNode(SogDataLabel, {
                  value: __props.price?.grossPrice,
                  "value-type": "Money"
                }, null, 8, ["value"]),
                _cache[3] || (_cache[3] = _createTextVNode(" ( ", -1)),
                _createVNode(SogDataLabel, {
                  value: __props.price?.shortPrice,
                  "value-type": "Money"
                }, {
                  default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                    _createTextVNode(" ) ", -1)
                  ]))]),
                  _: 1
                }, 8, ["value"])
              ])
            ], 512), [
              [_vShow, __props.price?.productTypeId!==_unref(ProductType).ExportBlank]
            ]),
            _withDirectives(_createElementVNode("tr", null, [
              _createElementVNode("td", null, [
                _createVNode(SogDataLabel, {
                  value: __props.price?.minSaleGrossPrice,
                  "value-type": "Money"
                }, null, 8, ["value"]),
                _cache[5] || (_cache[5] = _createTextVNode(" ( ", -1)),
                _createVNode(SogDataLabel, {
                  value: __props.price?.minSaleShortPrice,
                  "value-type": "Money"
                }, {
                  default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                    _createTextVNode(" ) ", -1)
                  ]))]),
                  _: 1
                }, 8, ["value"])
              ])
            ], 512), [
              [_vShow, __props.price?.productTypeId!==_unref(ProductType).ExportBlank && __props.price?.minSaleGrossPrice && __props.price?.grossPrice!==__props.price?.minSaleGrossPrice]
            ]),
            _withDirectives(_createElementVNode("tr", null, [
              _createElementVNode("td", null, [
                _cache[6] || (_cache[6] = _createTextVNode(" Referenznr. ", -1)),
                _createVNode(SogDataLabel, {
                  value: __props.price?.productRefId
                }, null, 8, ["value"])
              ])
            ], 512), [
              [_vShow, __props.price?.productRefId]
            ])
          ])
        ]),
        _: 1
      }),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["class"]))
}
}

})